import { assertTechnicianCheckDoctorUnchanged } from "./BookingTechnicianReportCheck";

const AUTOMATION_FIELD_PREFIXES = [
  "office",
  "techTransfer",
  "doctorTransfer",
  "monitor",
  "reportValidation",
  "technicianReportCheck",
];

const isAutomationField = (fieldName) =>
  AUTOMATION_FIELD_PREFIXES.some((prefix) => fieldName.startsWith(prefix));

const getAutomationFields = (extendedProps = {}) =>
  Object.entries(extendedProps || {}).reduce((result, [fieldName, value]) => {
    if (isAutomationField(fieldName)) result[fieldName] = value;
    return result;
  }, {});

const getNonAutomationFields = (extendedProps = {}) =>
  Object.entries(extendedProps || {}).reduce((result, [fieldName, value]) => {
    if (!isAutomationField(fieldName)) result[fieldName] = value;
    return result;
  }, {});

// Calendar and table editors save the complete extendedProps map. Keep fields
// owned by the Center/transfer automation from the newest Firestore snapshot so
// an editor that was opened earlier cannot put an old workflow status back.
export const mergeBookingExtendedPropsWithAutomationState = (
  editedExtendedProps = {},
  latestExtendedProps = {},
  nextDoctor = editedExtendedProps.doctor,
  nextHn = editedExtendedProps.hn,
) => {
  assertTechnicianCheckDoctorUnchanged(latestExtendedProps, nextDoctor);
  return {
    ...getNonAutomationFields(editedExtendedProps),
    ...getAutomationFields(latestExtendedProps),
    // Incoming DOB corrections must survive an editor opened before the save.
    ...Object.fromEntries(["dateOfBirth", "dob"]
      .filter(field => String(nextHn || "") === String(latestExtendedProps.hn || "") && Object.prototype.hasOwnProperty.call(latestExtendedProps, field))
      .map(field => [field, latestExtendedProps[field]])),
  };
};
